var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('v-icon',[_vm._v("mdi-file")]),_vm._v(" "+_vm._s(_vm.$t('supplier-invoice'))+" ")],1),_c('v-card-text',[_vm._v(" test ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }